import { BrowserType } from '../browser.service';

export const videoEffectsBrowsers = [BrowserType.CHROME, BrowserType.EDGE, BrowserType.FIREFOX];
export const trackProcessorBrowsers: BrowserType[] = [BrowserType.CHROME, BrowserType.EDGE];

export const doesBrowserSupportVideoEffects = (browserType: BrowserType) => videoEffectsBrowsers.includes(browserType);
export const doesBrowserSupportTrackProcessor = (browserType: BrowserType) =>
  trackProcessorBrowsers.includes(browserType);

export const getBrowserEffectFPS = (browserType: BrowserType) => {
  // Safari and firefox don't honor FPS constraints
  if (browserType === BrowserType.SAFARI || browserType === BrowserType.FIREFOX) {
    return 30;
  }
  return 18;
};
